import { Component, OnInit } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import { User } from '../../models/user';
import * as _ from 'lodash';
import { FollowService } from '../../services/follow.service';


@Component({
  selector: 'app-follow',
  templateUrl: './follow.component.html',
  styleUrls: ['./follow.component.css']
})
export class FollowComponent implements OnInit {

  currentUser;

  userCollection: AngularFirestoreCollection<User>;
  users: Observable<User[]>;

  // filter
  userF: any;
  filteredUsers: any;
  // filterProperties
  filterUid: string;
  filters = {};

  public followers$: Observable<any[]>;
  public following$: Observable<any[]>;

  followerCollection: AngularFirestoreCollection<any>;
  follower: Observable<any[]>;


  followingCollection: AngularFirestoreCollection<any>;
  following: Observable<any[]>;

  followingRef;


   colA = {
    Hz6NkEhA7HeQbYv1D9cF1nJW9qg1: true,
    IpU5WL7NcCcPP54Y20awU0SgdGu2: true,
    L1TOEwgwtbMjVBWMvbrZDvQprO72: true,
    PzoRPT0YPxMP6xCBxioGk2bigzN2: false,
    Q45P0PgObWPsbm0TwrUjwUAd5rT2: true,
  };
  
   colB = {
    0: {
      id: 'Hz6NkEhA7HeQbYv1D9cF1nJW9qg1'
    },
    1: {
      id: 'Q45P0PgObWPsbm0TwrUjwUAd5rT2'
    },
    2: {
      id: 'PzoRPT0YPxMP6xCBxioGk2bigzN2'
    }
  };

  constructor(private afs: AngularFirestore,  private afAuth: AngularFireAuth, private followService: FollowService) { }

  ngOnInit() {

    this.afAuth.authState.subscribe(userData => {
      this.currentUser = userData.uid;

      this.userCollection = this.afs.collection('users', ref => {
        return ref;
      });
      this.users = this.userCollection.valueChanges();

      this.afs.collection('users').valueChanges().subscribe( users => {
        this.userF = users;
      });

      this.afs.collection('following').doc(`${this.currentUser}`).valueChanges().subscribe( ref => {
        this.followingRef = ref;
        console.log('those are all my followers', this.followingRef);
      });

      this.myFilter();

      console.log('this is my id I pass over:', this.currentUser);
      this.followers$ = this.followService.getFollowers$(this.currentUser);
      this.following$ = this.followService.getFollowing$(this.currentUser);

    });

        
        const colC = _.pickBy(this.colB, val => this.colA[val.id]);
        console.log(colC);

        const colX = _.pickBy(this.colA, val => val.id in this.colB);
        console.log(colX);


        const test = _.pickBy(this.colA);
        console.log('this is my test', test);

       const colD = _.pickBy(this.colB, val => val.id in test);
        console.log('my final object', colD);
       




  } // ngOnInit


  private applyFilters() {
    this.filteredUsers = _.pickBy(this.userF,   { uid: 'Hz6NkEhA7HeQbYv1D9cF1nJW9qg1'});
  }


  private myFilter() {
    const filtU = _.pickBy(this.followingRef);
    this.filteredUsers = _.pickBy(this.userF, val => val.id in filtU);
    console.log(this.filteredUsers);
  }




}






// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/follow/follow.component.ts